import {
  INITIATE_REPORT,
  REQUEST_REPORT,
  CLEAR_REPORT,
  SET_REPORT,
} from 'actions/types'
import restApi from 'apis/restApi'
import { fetchToken } from 'utils/authUtils'

const reportEndPoint = '/report'

// Pass data to reducers
export const setReport = (obj, type, headers, report) => {
  const action = { type: type, payload: obj, headers: headers }
  if (report) action.currentReport = report
  return action
}

export const fetchAndWaitForReport =
  (report_request_id) => async (dispatch) => {
    const getReport = async () =>
      await restApi.get(`${reportEndPoint}/status/${report_request_id}`, {
        responseType: 'blob',
        headers: { Authorization: `Bearer ${fetchToken()}` },
      })

    const waitForReport = async () => {
      await new Promise((res) => setTimeout(res, 1500))
      const res = await getReport()
      if (res.status !== 200 || res.data?.type === 'application/json') {
        return waitForReport()
      } else {
        return res
      }
    }

    if (fetchToken()) {
      const res = await waitForReport()
      dispatch(setReport(res.data, SET_REPORT, res.headers))
    }
  }

export const clearReport = () => async (dispatch) => {
  dispatch(setReport('', CLEAR_REPORT))
}

export const requestReport = (report_id, params) => async (dispatch) => {
  if (fetchToken()) {
    dispatch(setReport(null, INITIATE_REPORT))

    // if this is a request for a wip report trigger a request loop for updating the wip milestones
    if (report_id === 4) {
      let continuation_token = 0
      while (continuation_token !== null && continuation_token > -1) {
        const result = await restApi.post(
          `${reportEndPoint}/updateWipMilestones`,
          params,
          {
            headers: { Authorization: `Bearer ${fetchToken()}` },
            params: {
              continuation_token: continuation_token,
              page_size: 10,
            },
          }
        )

        if (result.status === 200) {
          continuation_token = result.data?.continuation_token ?? -1
        } else {
          continuation_token = null
          clearReport()(dispatch)
          alert(
            'Error updating wip milestones. Please try again later and / or contact support.'
          )
        }
      }
    }

    const res = await restApi.post(`${reportEndPoint}/${report_id}`, params, {
      headers: { Authorization: `Bearer ${fetchToken()}` },
    })
    dispatch(setReport(res.data, REQUEST_REPORT))
  }
}
